import { render, staticRenderFns } from "./GeneralComplaintList2.vue?vue&type=template&id=0e83381c&scoped=true&"
import script from "./GeneralComplaintList2.vue?vue&type=script&lang=js&"
export * from "./GeneralComplaintList2.vue?vue&type=script&lang=js&"
import style0 from "./GeneralComplaintList2.vue?vue&type=style&index=0&id=0e83381c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83381c",
  null
  
)

export default component.exports